import React, { Component } from "react";
import { connect } from "react-redux";

class PageNotFound extends Component {
    render() {
        return (
            <div className="wrapper page-start">
                <div className="container-fluid">
                    <div className="page-not-found row">
                        <div className="col-xs-24 page-not-found__wrapper">
                            <div className="row bottom-xs  page-not-found__wrapper--mod">
                                <div className="col-xs-24 col-md-12 col-lg-16 page-not-found__text-wrapper">
                                    <h1 className="page-not-found__text-wrapper__title-big">
                                        Ups, hier geht's
                                    </h1>
                                    <h2 className="page-not-found__text-wrapper__title-medium">
                                        gerade nicht weiter.
                                    </h2>
                                    <p className="page-not-found__text-wrapper__text">
                                        Lieber MediaMarkt Tarifwelt Kunde,
                                    </p>
                                    <p className="page-not-found__text-wrapper__text">
                                        das tut uns leid... hier geht es gerade
                                        nicht weiter. Du befindest dich auf
                                        einer Seite, die es aktuell nicht (mehr)
                                        gibt. Keine Panik! Klicke doch
                                        einfach weiter und schaue dir
                                        viele weitere Angebote in unserer
                                        Tarifwelt an.
                                    </p>
                                    <p className="page-not-found__text-wrapper__text">
                                        Dein MediaMarkt Tarifwelt Team
                                    </p>
                                </div>
                                <div className="col-xs-24 col-md-12 col-lg-8 page-not-found__link-wrapper">
                                    <a
                                        href="/"
                                        className="page-not-found__text-wrapper__link"
                                        name="button_home"
                                    >
                                        Zur Startseite
                                    </a>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-2">
                                    <div className="page-not-found__image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state) => ({
    browser: state.page.browser,
}))(PageNotFound);
